import React from 'react';

export default function Projects(){
    return (
        <div id="work" className="portfolio-mf sect-pt4 route">
               <div className="container">
                 <div className="row">
                   <div className="col-sm-12">
                     <div className="title-box text-center">
                       <h5 className="title-a">
                         Projects
                       </h5>
                       
                       <div className="line-project"></div>
                     </div>
                   </div>
                 </div>
                 <div className="row">
                   <div className="col-md-4">
                     <div className="work-box">
                       <a href="https://izuwy.csb.app/" target="_blank">
                         <div className="work-img">
                           <img src="img/wallet.jpg" alt="" className="img-fluid"/>
                         </div>
                         <div className="work-content">
                           <div className="row">
                             <div className="col-sm-8">
                               <h2 className="w-title">E-Wallet</h2>
                               <div className="w-more">
                                 <span className="w-ctegory">Web Application</span> / <span className="w-date">Feb. 2021</span>
                               </div>
                             </div>
                           </div>
                           <div><span className="w-date">Online custumized Wallet app </span></div>
                         </div>
                       </a>
                     </div>
                   </div>
                   <div className="col-md-4">
                     <div className="work-box">
                       <a href="https://github.com/Nourcova/e-track-web" target="_blank">
                         <div className="work-img">
                           <img src="img/etrack.png" alt="" className="img-fluid"/>
                         </div>
                         <div className="work-content">
                           <div className="row">
                             <div className="col-sm-8">
                               <h2 className="w-title">E-Track</h2>
                               <div className="w-more">
                                 <span className="w-ctegory">Web Application</span> / <span className="w-date">Mar. 2021</span>
                               </div>
                             </div>
                           </div>
                           <div><span className="w-date">Online custumized bullet journal </span></div>
                         </div>
                       </a>
                     </div>
                   </div>
                   <div className="col-md-4">
                     <div className="work-box">
                       <a href="https://todolist-final.nourcova.repl.co/" target="_blank">
                         <div className="work-img">
                           <img src="img/todo.jpg" alt="" className="img-fluid"/>
                         </div>
                         <div className="work-content">
                           <div className="row">
                             <div className="col-sm-8">
                               <h2 className="w-title">Todo List</h2>
                               <div className="w-more">
                                 <span className="w-ctegory">Web Application</span> / <span className="w-date">Jan. 2021</span>
                               </div>
                             </div>
                           </div>
                           <div><span className="w-date">Todo List app</span></div>
                         </div>
                       </a>
                     </div>
                   </div>
                   <div className="col-md-4">
                     <div className="work-box">
                       <a href="https://s3-eu-west-1.amazonaws.com/games.triocodestudio.com/SlimeRights/index.html" target="_blank">
                         <div className="work-img">
                           <img src="img/slimeright.JPG" alt="" className="img-fluid"/>
                         </div>
                         <div className="work-content">
                           <div className="row">
                             <div className="col-sm-8">
                               <h2 className="w-title">Slime Right</h2>
                               <div className="w-more">
                                 <span className="w-ctegory">Game</span> / <span className="w-date">18 Sep. 2018</span>
                               </div>
                             </div>
                           </div>
                           <div><span className="w-date">3D Game made in a Gamejam</span></div>
                         </div>
                       </a>
                     </div>
                   </div>
                   
                 </div>
               </div>
               </div>
    );
}